// extracted by mini-css-extract-plugin
module.exports = {"personalShopperModal":"style_personalShopperModal__JsidW","personalShopperWrapper":"style_personalShopperWrapper__jz6Vz"};